import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const Provozovna = {
	name: NAME,
	router,
	apiProvider,
};
